import React from 'react'
import { Form } from 'react-bootstrap'
import { BrowserView, MobileView } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcFlexBox,
  PixelCheckboxGroup,
  PixelCollapse,
  PixelDiv,
  PixelDropDown,
  PixelFactoryContext,
  PixelFlexBox,
  PixelPageContainer,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'
import {
  geRolePermissions,
  get,
  put,
  updateRolePermissions,
} from 'utils/api-routes.util'
import ChevronDownIcon from 'utils/icons/chevron-down-icon'
import ChevronUpIcon from 'utils/icons/chevron-up-icon'
import { IPixelFactory } from '../../../../../decl.d'

const UserRoles = () => {
  const [roles, setRoles] = React.useState<any[]>([])
  const [statusPermissions, setStatusPermissions] = React.useState<any>()
  const [activeRole, setActiveRole] = React.useState(null)
  const { showLoader, hideLoader, showSuccess } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)
  const [expandedItems, setExpandedItems] = React.useState<
    Record<number, boolean>
  >({})

  const getAllUserRoles = () => {
    showLoader(mainSectionRef)
    get('/settings/users/roles').subscribe((res: any) => {
      setRoles(res.response.data)
      setActiveRole(res.response.data[0].id)
      getPermission(res.response.data[0], 0, res.response.data)
      hideLoader(mainSectionRef)
    })
  }
  const getAllStatusPermissions = () => {
    showLoader(mainSectionRef)
    get(`/settings/users/roles/${activeRole}/permissions/status`).subscribe(
      (res: any) => {
        setStatusPermissions(res.response)
        hideLoader(mainSectionRef)
      },
    )
  }
  const updateAllStatusPermissions = (data) => {
    showLoader(mainSectionRef)
    put(
      `/settings/users/roles/${activeRole}/permissions/status`,
      data,
    ).subscribe((res: any) => {
      if (res.status === 200) {
        showSuccess('status updated successfully')
      }
      hideLoader(mainSectionRef)
    })
  }

  const breadcrumbs = [
    {
      name: 'Settings',
      active: false,
    },
    {
      name: 'Users Roles',
      active: true,
    },
  ]

  React.useEffect(() => {
    getAllUserRoles()
  }, [])
  React.useEffect(() => {
    getAllStatusPermissions()
  }, [activeRole])

  const handleClick = (role: any, i: number) => {
    setActiveRole(role.id)
    getRolesPermissions(role, i)
  }

  const getRolesPermissions = (role, i) => {
    if (!role['status_permissions'] && !role['module_permissions']) {
      getPermission(role, i, roles)
    }
  }

  const getPermission = (role, i, allRoles) => {
    showLoader(mainSectionRef)
    geRolePermissions(role['id']).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response && res.response['data']) {
        role['module_permissions'] = res.response['data']
        role['module_permissions'].map((p) => {
          if (p['allowed_module']) {
            p['module_model'] = p['id']
          } else {
            p['module_model'] = false
          }
        })
        const changedRoles = [...allRoles]
        changedRoles[i] = role
        setRoles(changedRoles)
      }
    })
  }

  const changeModulePermissions = (e, role_id) => {
    const data = {
      enable: e.target.checked,
      id: e.target.value,
      type: 'module',
    }
    updatePermissions(e, role_id, data)
  }

  const updatePermissions = (e, role_id, data) => {
    showLoader(mainSectionRef)
    updateRolePermissions(role_id, data).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (!res.response.error) {
        showSuccess(`Successfully ${data.enable ? 'Enabled' : 'Disabled'}`)
      }
    })
  }

  const getRoleByID = (id) => {
    return roles.find((r) => r.id === id)
  }

  const IsChecked = (id) => {
    if (!statusPermissions || !Array.isArray(statusPermissions)) {
      return false
    }
    const permission = statusPermissions.find(
      (p) => p.status_classification_id === id,
    )
    if (!permission || !permission.permissions) {
      return false
    }
    return permission.permissions.every((item) => item.permissions === true)
  }

  const getLabel = (id) => {
    return id == '1'
      ? 'New'
      : id == '2'
      ? 'Processing'
      : id == '3'
      ? 'Tracking'
      : id == '4'
      ? 'Complete'
      : id == '5'
      ? 'Cancelled'
      : id == '6'
      ? 'Returns'
      : id == '7'
      ? 'Post Delivery'
      : ''
  }

  return (
    <>
      <DcFlexBox
        height="60px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer padding="0">
        <Section noPadding style={{ padding: '0' }}>
          <SectionContent
            noPadding
            style={{ borderRadius: '0px', padding: '0' }}
          >
            <DcFlexBox height="auto" style={{ padding: ' 0 20px' }}>
              <BrowserView>
                <PixelFlexBox
                  width="100%"
                  flexWrap="wrap"
                  justifyContent="flex-start"
                  alignItems="center"
                  alignContent="flex-start"
                >
                  {roles.map((role: any, i: number) => (
                    <FilterButton
                      className={activeRole === role.id ? 'active' : ''}
                      key={role.id}
                      onClick={() => handleClick(role, i)}
                    >
                      {role.description}
                    </FilterButton>
                  ))}
                </PixelFlexBox>
              </BrowserView>
              <MobileView>
                <PixelDropDown
                  customLabel=""
                  style={{ marginBottom: '15px' }}
                  options={roles.map((option) => {
                    return {
                      label: `${option.description} (${option.users_count})`,
                      value: option.id,
                    }
                  })}
                  placeholder={'Select Role'}
                  required
                  value={activeRole || ''}
                  onChange={(e) => {
                    const r = getRoleByID(e.target.value)
                    handleClick(r, 0)
                  }}
                />
              </MobileView>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 100px)',
            minHeight: 'calc(100vh - 100px)',
            overflow: 'auto',
          }}
        >
          <SectionContent
            style={{
              height: 'calc(100vh - 145px)',
              minHeight: 'calc(100vh - 145px)',
            }}
            className="roles fullheight"
            ref={mainSectionRef}
          >
            {roles &&
              getRoleByID(activeRole) &&
              getRoleByID(activeRole).module_permissions && (
                <PixelFlexBox
                  flexDirection="column"
                  gap="10px"
                  backgroundColor="#f7f7f8"
                  style={{
                    boxShadow: 'inset 0px 0px 4px #f7f7f8',
                    borderRadius: '5px',
                    overflow: 'auto',
                  }}
                >
                  <PixelFlexBox
                    style={{ borderBottom: '1px solid rgb(230, 230, 230)' }}
                    width="100%"
                    height="auto"
                  >
                    <PixelDiv
                      style={{
                        borderRight: '1px solid rgb(230, 230, 230)',
                        width: '50%',
                        padding: '10px',
                        height: 'auto',
                      }}
                    >
                      <PixelText
                        style={{
                          width: '50%',
                          fontSize: '16px',
                          fontWeight: '600',
                          height: 'auto',
                        }}
                      >
                        Module Permissions
                      </PixelText>
                    </PixelDiv>
                    <PixelDiv
                      style={{
                        borderRight: '1px solid rgb(230, 230, 230)',
                        width: '50%',
                        padding: '10px',
                      }}
                    >
                      <PixelText
                        style={{
                          width: '50%',
                          fontSize: '16px',
                          fontWeight: '600',
                        }}
                      >
                        Status Permissions
                      </PixelText>
                    </PixelDiv>
                  </PixelFlexBox>
                  <PixelFlexBox>
                    <PixelFlexBox flexDirection="column">
                      {getRoleByID(activeRole).module_permissions?.map(
                        (permission: any, i: number) => (
                          <PixelFlexBox key={i} height="auto">
                            <PixelFlexBox
                              flexDirection="row"
                              flexWrap="wrap"
                              alignItems="center"
                              width="100%"
                              padding="10px"
                              gap="10px"
                              style={{
                                borderBottom: '1px solid #e6e6e6',
                                fontWeight: '500',
                                color: '#878c90',
                              }}
                              key={permission.id}
                            >
                              <PixelCheckboxGroup
                                className=""
                                label={''}
                                options={[
                                  {
                                    label: permission.label,
                                    value: permission.id,
                                    type: 'checkbox',
                                    checked: !!permission.module_model,
                                  },
                                ]}
                                onChange={(e) => {
                                  const changedRoles = [...roles]
                                  changedRoles.map((role) => {
                                    if (role.id === activeRole) {
                                      role.module_permissions[i].module_model =
                                        e.target.checked
                                    }
                                    return role
                                  })
                                  setRoles(changedRoles)
                                  changeModulePermissions(e, activeRole)
                                }}
                              />
                            </PixelFlexBox>
                          </PixelFlexBox>
                        ),
                      )}
                    </PixelFlexBox>
                    <PixelFlexBox flexDirection="column">
                      {statusPermissions?.map((item, i) => {
                        const classificationId = item?.status_classification_id
                        const isItemExpanded =
                          expandedItems[classificationId] || false

                        return (
                          <div key={i} style={{ position: 'relative' }}>
                            <Form.Check
                              style={{
                                position: 'absolute',
                                left: '15px',
                                top: '13px',
                                width: 'auto',
                              }}
                              key={classificationId}
                              label={getLabel(classificationId)}
                              value={classificationId}
                              checked={IsChecked(classificationId)}
                            >
                              <Form.Check.Input
                                value={classificationId}
                                checked={IsChecked(classificationId)}
                                onChange={(e: any) => {
                                  const checked = e.target.checked
                                  const targetClassificationId = Number(
                                    e.target.value,
                                  )

                                  const updatedPermissions =
                                    statusPermissions.map((statusClass) => {
                                      if (
                                        statusClass.status_classification_id ===
                                        targetClassificationId
                                      ) {
                                        return {
                                          ...statusClass,
                                          permissions:
                                            statusClass.permissions.map(
                                              (permission) => ({
                                                ...permission,
                                                permissions: checked,
                                              }),
                                            ),
                                        }
                                      }
                                      return statusClass
                                    })

                                  setStatusPermissions(updatedPermissions)

                                  const statusClass = updatedPermissions.find(
                                    (sc) =>
                                      sc.status_classification_id ===
                                      targetClassificationId,
                                  )

                                  if (statusClass) {
                                    updateAllStatusPermissions(
                                      statusClass.permissions.map((perm) => ({
                                        status_id: perm.status_id,
                                        is_permitted: checked,
                                      })),
                                    )
                                  }
                                }}
                              />

                              <Form.Check.Label
                                style={{ color: '#878c90', fontWeight: '500' }}
                              >
                                {getLabel(classificationId)}
                              </Form.Check.Label>
                            </Form.Check>
                            <PixelCollapse
                              defaultExpanded={false}
                              onCollapseChange={(isExpanded) => {
                                setExpandedItems((prev) => ({
                                  ...prev,
                                  [classificationId]: isExpanded,
                                }))
                              }}
                              collapseController={
                                <PixelDiv
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: 'nowrap',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                    borderRadius: '5px',
                                    textDecoration: 'none',
                                    width: '99%',
                                    marginTop: '3px',
                                    padding: '12px',
                                    marginLeft: '5px',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    boxShadow: '0px 0px 2px #ccc',
                                  }}
                                >
                                  <PixelDiv
                                    style={{
                                      justifyContent: 'space-between',
                                      width: '90%',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                    id="collapse-controller"
                                  >
                                    <PixelText
                                      style={{
                                        color: '#878c90',
                                        fontWeight: '500',
                                        margin: '0',
                                      }}
                                    >
                                      .
                                    </PixelText>
                                  </PixelDiv>
                                  <PixelDiv
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                      height: '20px',
                                      width: '10%',
                                    }}
                                    id="collapse-controller"
                                  >
                                    {isItemExpanded ? (
                                      <ChevronDownIcon
                                        size={18}
                                        color={$DCprimaryColor}
                                      />
                                    ) : (
                                      <ChevronUpIcon
                                        size={18}
                                        color={$DCprimaryColor}
                                      />
                                    )}
                                  </PixelDiv>
                                </PixelDiv>
                              }
                            >
                              <div style={{ padding: '0px 4px' }}>
                                <PixelFlexBox
                                  style={{
                                    width: '100%',
                                    flexDirection: 'column',
                                    flexWrap: 'nowrap',
                                    justifyContent: 'flex-start',
                                    alignItems: 'flex-start',
                                    alignContent: 'center',
                                    overflow: 'auto',
                                  }}
                                >
                                  <Section style={{ padding: '0px' }}>
                                    {item?.permissions?.map(
                                      (permission: any, i: number) => (
                                        <PixelFlexBox key={i}>
                                          <PixelFlexBox
                                            flexDirection="row"
                                            flexWrap="wrap"
                                            alignItems="center"
                                            width="100%"
                                            padding="10px 10px 10px 20px"
                                            gap="10px"
                                            style={{
                                              borderRight: '1px solid #e6e6e6',
                                              borderLeft: '1px solid #e6e6e6',
                                              borderBottom: '1px solid #e6e6e6',
                                              fontWeight: '400',
                                              color: '#878c90',
                                              fontSize: '12px',
                                            }}
                                            key={permission.status_id}
                                          >
                                            <PixelCheckboxGroup
                                              className=""
                                              label={''}
                                              options={[
                                                {
                                                  label:
                                                    permission.status_label,
                                                  value: permission.status_id,
                                                  type: 'checkbox',
                                                  checked:
                                                    !!permission.permissions,
                                                },
                                              ]}
                                              onChange={(e) => {
                                                const status_id =
                                                  e.target.defaultValue
                                                const is_permitted =
                                                  e.target.checked

                                                const updatedStatusPermissions =
                                                  statusPermissions.map(
                                                    (statusClassification) => ({
                                                      ...statusClassification,
                                                      permissions:
                                                        statusClassification.permissions.map(
                                                          (perm) => {
                                                            if (
                                                              perm.status_id ===
                                                              status_id
                                                            ) {
                                                              return {
                                                                ...perm,
                                                                permissions:
                                                                  is_permitted,
                                                              }
                                                            }
                                                            return perm
                                                          },
                                                        ),
                                                    }),
                                                  )

                                                setStatusPermissions(
                                                  updatedStatusPermissions,
                                                )

                                                updateAllStatusPermissions([
                                                  {
                                                    is_permitted,
                                                    status_id,
                                                  },
                                                ])
                                              }}
                                            />
                                          </PixelFlexBox>
                                        </PixelFlexBox>
                                      ),
                                    )}
                                  </Section>
                                </PixelFlexBox>
                              </div>
                            </PixelCollapse>
                          </div>
                        )
                      })}
                    </PixelFlexBox>
                  </PixelFlexBox>
                </PixelFlexBox>
              )}
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const FilterButton = styled.button`
  /* background-color: #f7f7f8; */
  border: none;
  /* border-radius: 5px; */
  padding: 7px 10px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(120, 124, 158);
  cursor: pointer;
  border-right: none;
  background-color: #ffff;
  /* margin: 0 7px; */
  text-transform: capitalize;
  letter-spacing: 0.6px;
  animation: 0.2s ease;
  transition: all 0.5s ease 0s;
  transform: translate3d(0px, 0px, 0px);
  &:hover {
    color: ${$DCprimaryColor};
  }
  &.active {
    /* background-color: #ffffff; */
    border-bottom: 2px solid ${$DCprimaryColor};
    color: ${$DCprimaryColor};
    font-weight: 600;
    /* box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.67);
    -webkit-box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.67); */
  }
`

export default UserRoles
